import { UUID } from "../generic/uuid";
import { WineTypeDto } from "@vini-wine/core-dtos";

export interface WineTypeModel extends UUID {
  // available includes
  mappedItems?: any;

  // transform
  name: string;
}

export const createWineTypeDtoFromAdminWineTypeModel = (
  wineType: WineTypeModel,
): WineTypeDto => {
  return {
    uuid: wineType.uuid,
    name: wineType.name,
  };
};
